import { Component, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslationService } from '../../services/translation.service';
import type { SearchTranslations } from '../../i18n/search';
import en from '../../i18n/en/search';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements AfterViewInit {
  @ViewChild('searchInput') searchInputRef!: ElementRef<HTMLInputElement>;
  searchQuery = '';
  @Output() searchApplications = new EventEmitter<string>();
  @Output() close = new EventEmitter<void>();

  translations: SearchTranslations = en as SearchTranslations;

  constructor(private translationService: TranslationService) {
    const current = this.translationService.getSearchTranslations();
    if (current) {
      this.translations = current;
    }
    this.translationService.onChange(() => {
      const next = this.translationService.getSearchTranslations();
      if (next) {
        this.translations = next;
      }
    });
  }

  get t(): SearchTranslations {
    return this.translations;
  }

  ngAfterViewInit() {
    this.focusInput();
  }

  focusInput() {
    setTimeout(() => {
      this.searchInputRef?.nativeElement?.focus();
    }, 0);
  }

  onSearchChange(event: any): void {
    this.searchQuery = event.target.value;
    this.searchApplications.emit(this.searchQuery);
  }

  clearAndClose() {
    this.searchQuery = '';
    this.searchApplications.emit('');
    this.close.emit();
  }
}
